import { useRef, useState } from 'react'

type MenuAlign = 'left' | 'right'

export const useMenuPosition = (estimatedMenuWidth = 300) => {
  const [menuAlign, setMenuAlign] = useState<MenuAlign>('left')
  const controlRef = useRef<HTMLDivElement>(null)

  const handleMenuOpen = () => {
    if (controlRef.current) {
      const control = controlRef.current.getBoundingClientRect()
      const viewportWidth = window.innerWidth
      const spaceOnRight = viewportWidth - control.left

      setMenuAlign(spaceOnRight < estimatedMenuWidth ? 'right' : 'left')
    }
  }

  return { menuAlign, controlRef, handleMenuOpen }
}
